import React from 'react';
import { selectSlideSection } from '@actions/creators';
import { useSlideData } from '@context/slide-data';

export const SectionLabel = ({section}) => {
    const { data, dispatch } = useSlideData();

    const selectSection = (evt) => {
        const { innerHTML } = evt.target;  
        const section = parseInt(innerHTML);

        dispatch(selectSlideSection(data.id, section));
    };
    
    return (
        <label
            className='section'
            onClick={selectSection}>
                {section}
        </label>
    );
};

export default SectionLabel;
